import { Currency } from "@/gql/graphql";

// Approximate exchange rates to AUD (updated periodically)
// These are rough estimates for summary purposes only
const EXCHANGE_RATES_TO_AUD: Record<Currency, number> = {
  [Currency.Aud]: 1.0,
  [Currency.Usd]: 1.52, // 1 USD ≈ 1.52 AUD
  [Currency.Eur]: 1.65, // 1 EUR ≈ 1.65 AUD
  [Currency.Gbp]: 1.95, // 1 GBP ≈ 1.95 AUD
  [Currency.Nzd]: 0.92, // 1 NZD ≈ 0.92 AUD
  [Currency.Cad]: 1.1, // 1 CAD ≈ 1.10 AUD
  [Currency.Jpy]: 0.01, // 1 JPY ≈ 0.010 AUD
  [Currency.Sek]: 0.14, // 1 SEK ≈ 0.14 AUD
  [Currency.Nok]: 0.14, // 1 NOK ≈ 0.14 AUD
  [Currency.Dkk]: 0.22, // 1 DKK ≈ 0.22 AUD
  [Currency.Fjd]: 0.68, // 1 FJD ≈ 0.68 AUD
  [Currency.Idr]: 0.0001, // 1 IDR ≈ 0.0001 AUD
  [Currency.Pgk]: 0.38, // 1 PGK ≈ 0.38 AUD
  [Currency.Sbd]: 0.18, // 1 SBD ≈ 0.18 AUD
  [Currency.Vuv]: 0.013, // 1 VUV ≈ 0.013 AUD
  [Currency.Xpf]: 0.014, // 1 XPF ≈ 0.014 AUD
  [Currency.Zar]: 0.085, // 1 ZAR ≈ 0.085 AUD
  [Currency.Twd]: 0.05, // 1 TWD ≈ 0.05 AUD
  [Currency.Brl]: 0.3, // 1 BRL ≈ 0.30 AUD
  [Currency.Clp]: 0.0016, // 1 CLP ≈ 0.0016 AUD
  [Currency.Ars]: 0.0016, // 1 ARS ≈ 0.0016 AUD
  [Currency.Aed]: 0.41, // 1 AED ≈ 0.41 AUD
  [Currency.Mxn]: 0.09, // 1 MXN ≈ 0.09 AUD
  [Currency.Krw]: 0.0012, // 1 KRW ≈ 0.0012 AUD
};

/**
 * Convert an amount from any currency to approximate AUD
 * @param amount Amount in cents/minor currency units
 * @param fromCurrency The source currency
 * @returns Approximate amount in AUD cents
 */
export function convertToAUD(amount: number, fromCurrency: Currency): number {
  const rate = EXCHANGE_RATES_TO_AUD[fromCurrency] || 1.0;
  return Math.round(amount * rate);
}

/**
 * Get the exchange rate from a currency to AUD
 * @param fromCurrency The source currency
 * @returns Exchange rate to AUD
 */
export function getExchangeRateToAUD(fromCurrency: Currency): number {
  return EXCHANGE_RATES_TO_AUD[fromCurrency] || 1.0;
}

/**
 * Check if currency conversion is needed (i.e., not already AUD)
 * @param currency The currency to check
 * @returns True if conversion is needed
 */
export function needsConversion(currency: Currency): boolean {
  return currency !== Currency.Aud;
}

/**
 * Get a disclaimer text for currency conversions
 * @returns Disclaimer text
 */
export function getCurrencyConversionDisclaimer(): string {
  return "Totals converted to AUD using approximate exchange rates for summary purposes only.";
}
